import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";

interface IIcon {
  color: string;
}

const TraceIcon: React.FC<IIcon> = ({ color }) => {
  return <FontAwesomeIcon icon={faLocationArrow} style={{ color }} />;
};

export default TraceIcon;
